import { Component, Prop, h } from '@stencil/core';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';
import EventEmitterComponent from '../event-emitter-component/event-emitter-component';

@Component({
  tag: 'uiaas-search-conversational-search-new-conversation-cta',
  styleUrl: 'new-conversation-cta.scss',
  shadow: true,
})
export class ConversationalSearchNewConversationCta {
  @Prop() readonly labelProvider: labelProviderInterface;
  @Prop() readonly isTextAreaDisabled: boolean;
  @Prop() readonly query: string;
  render() {
      const text = this.labelProvider(
        'conversational.search.new.conversation',
        'New Topic',
      );

      return (
        <EventEmitterComponent eventName='conversational-search:user-new-conversation-trigger'>
          <EventEmitterComponent
            eventName='conversational-search:ga-cta'
            ctaName='New Topic'
            keyword={this.query}
          >
            <qds-button
              disabled={this.isTextAreaDisabled}
              importance="standard"
              icon-name="chat-bubbles"
              icon-library="default"
              size="large"
              variant="hero"
              text={text}
            />
          </EventEmitterComponent>
        </EventEmitterComponent>
      );
  }
}
